import { toast } from "react-toastify"

const actionHelper = ({ confirmation, callback, texts }) => {
    const action = () => {
        if (texts) {
            toast.promise(callback, {
                success: texts?.success,
                pending: texts?.pending,
            })
        } else {
            callback()
        }
    }

    if (confirmation) {
        let body = (
            <>
                <div className="flex flex-col">
                    <span>{confirmation.label}</span>
                    <div className="check-action__actions">
                        <button className="check-action__button">لغو</button>
                        <button onClick={action} className={"px-2 check-action__button " + confirmation?.color}>
                            {confirmation.actionLabel}
                        </button>
                    </div>
                </div>
            </>
        )

        return toast(body)
    } else {
        action()
    }
}

export default actionHelper
